import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {

  constructor(private http: HttpClient) { }

  downloadFile(url: string): Observable<File> {

    return this.http.get(url, { responseType: 'blob', observe: 'response' })
      .pipe(
        map(response => {

          let filename = '';
          // try to get filename from Content-Disposition header
          const contentDisposition = response.headers.get('content-disposition');
          if (contentDisposition) {
            
            filename = contentDisposition.split('filename=')[1];
          }
          // if filename is still empty, try to parse it from the URL
          if (!filename) {

            const parts = url.split('/');
            filename = parts[parts.length - 1];
          }

          const file = new File([response.body], filename);
          return file;
        })
      );
  }
}